import { POINTER_EVENTS } from "@excalidraw/common";
import { WelcomeScreen } from "@excalidraw/excalidraw/index";
import { PlusIcon } from "@excalidraw/excalidraw/components/icons";
import React from "react";

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  onCreateBoard?: () => any;
  isCollabEnabled: boolean;
}> = React.memo((props) => {
  return (
    <WelcomeScreen>
      <WelcomeScreen.Hints.ToolbarHint />
      <WelcomeScreen.Hints.HelpHint />
      <WelcomeScreen.Center>
        <WelcomeScreen.Center.Heading>
          <span style={{ pointerEvents: POINTER_EVENTS.inheritFromUI }}>
            Echomotion Whiteboard
          </span>
        </WelcomeScreen.Center.Heading>
        <WelcomeScreen.Center.Menu>
          {props.isCollabEnabled && props.onCreateBoard && (
            <WelcomeScreen.Center.MenuItem
              onSelect={() => props.onCreateBoard?.()}
              shortcut={null}
              icon={PlusIcon}
            >
              Neues Whiteboard erstellen
            </WelcomeScreen.Center.MenuItem>
          )}
          <WelcomeScreen.Center.MenuItemLoadScene />
          <WelcomeScreen.Center.MenuItemHelp />
          {props.isCollabEnabled && (
            <WelcomeScreen.Center.MenuItemLiveCollaborationTrigger
              onSelect={() => props.onCollabDialogOpen()}
            />
          )}
        </WelcomeScreen.Center.Menu>
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
